const vipProductList = [
  {
    id: 5,
    className: "flex-1",
    name: "基因溯源",
    label: 5999,
    tag: "",
  },
  {
    id: 6,
    className: "flex-1",
    name: "华大壹号",
    label: 7999,
    tag: "",
  },
  {
    id: 14,
    className: "flex-1",
    name: "雾化套装1",
    label: 3600,
    tag: "",
  },
  {
    id: 15,
    className: "flex-1",
    name: "雾化套装2",
    label: 3800,
    tag: "",
  },
  {
    id: 11,
    className: "flex-1",
    name: "华大壹号PLUS",
    label: 12000,
    tag: "",
  },
  {
    id: 8,
    className: "flex-1",
    name: "细胞存储",
    label: 9999,
    tag: "",
  },
  {
    id: 13,
    className: "flex-1",
    name: "IPSC时光胶囊",
    label: 9999,
    tag: "",
  },
];

export const list = [vipProductList];
export const expendList = [...vipProductList];

const org1184ProductList = vipProductList.filter(
  (product) => product.id === 5 || product.id === 11
);
export const org1184List = [org1184ProductList];
export const expendOrg1184List = [...org1184ProductList];

export const item = JSON.parse(
  JSON.stringify({
    personName: "",
    personIdCard: "",
    personPhone: "",
    checkStartTime: "",
    productList: [],
    sum: "",
    isGift: null, // 折扣：9折=9，8折=8，7折=7，默认null表示未选择
  })
);
